import { render, staticRenderFns } from "./ModalHistoricoCoResponsavel.vue?vue&type=template&id=ec7d87a0"
import script from "./ModalHistoricoCoResponsavel.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoCoResponsavel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports